/* eslint-disable sort-keys-fix/sort-keys-fix -- CSS-in-JS pseudo-selector keys use semantic ordering */
// MUI v4 NativeSelect, NS/Tractie select-pendant overrides (native variant).
// Tractie source: select (native variant).
// Tractie's select gebruikt native <select> met inline-SVG
// chevron; MuiNativeSelect mapt 1:1. Cluster 13 control-sizing tokens drive
// height/padding, cluster 6 spacing tokens drive chevron-area inset.
//
// Token references (Tractie -> NS):
//   - chevron color: --tractie-color-content-emphasis -> --ns-color-fg-emphasis (cluster 2)
//   - chevron inset-inline-end: --tractie-spacing-spacer-3 (12px) -> --ns-space-3 (cluster 6)
//   - right-padding (chevron-area): --tractie-spacing-spacer-10 (40px) -> --ns-space-10 (cluster 6)
//   - chevron 24x24: --ns-control-icon-size-l (cluster 13)
//   - height/padding inherits from input basis (--ns-control-height-m,
//     --ns-control-padding-y-m, --ns-control-padding-x-m).

export const MuiNativeSelectLightOverrides = {
  root: {},

  select: {
    minHeight: 'var(--ns-control-height-m)',
    boxSizing: 'border-box' as const,
    paddingTop: 'var(--ns-control-padding-y-m)',
    paddingBottom: 'var(--ns-control-padding-y-m)',
    paddingLeft: 'var(--ns-control-padding-x-m)',
    color: 'var(--ns-color-fg-default)',
    '&&': {
      paddingRight: 'var(--ns-space-10)',
    },
    '&:focus': {
      backgroundColor: 'transparent',
      borderRadius: 0,
    },
    '&$disabled': {
      cursor: 'default' as const,
      pointerEvents: 'none' as const,
      opacity: 0.5,
    },
  },

  filled: {
    '&&': {
      paddingRight: 'var(--ns-space-10)',
    },
  },

  outlined: {
    borderRadius: 'var(--ns-control-radius)',
    '&&': {
      paddingRight: 'var(--ns-space-10)',
    },
  },

  selectMenu: {
    height: 'auto' as const,
    minHeight: 'var(--ns-control-height-m)',
    lineHeight: 1.5,
  },

  disabled: {},

  icon: {
    position: 'absolute' as const,
    right: 'var(--ns-space-3)',
    top: 'calc(50% - (var(--ns-control-icon-size-l) / 2))',
    width: 'var(--ns-control-icon-size-l)',
    height: 'var(--ns-control-icon-size-l)',
    pointerEvents: 'none' as const,
    color: 'var(--ns-color-fg-emphasis)',
    '&$disabled': {
      color: 'var(--ns-color-fg-subtle)',
    },
  },

  iconOpen: {
    transform: 'rotate(180deg)',
  },

  iconFilled: {
    right: 'var(--ns-space-3)',
  },

  iconOutlined: {
    right: 'var(--ns-space-3)',
  },

  nativeInput: {
    bottom: 0,
    left: 0,
    position: 'absolute' as const,
    opacity: 0,
    pointerEvents: 'none' as const,
    width: '100%',
  },
} as const;

// Dark spreads Light: token-driven, no mode-specific divergences.
export const MuiNativeSelectDarkOverrides = {
  ...MuiNativeSelectLightOverrides,
} as const;
